import { userConstants } from '../_constants';

let user = localStorage.getItem('access_token');

const initialState = user ? { loggedIn: true } : { loggedIn: false };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      // console.log("login success")

      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {};
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/authentication.reducer.js